import primary from './primary'
import secondary from './secondary'

const routes = [
  ...primary,
  ...secondary,
]

export default routes
